<template>
  <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                Employee Form
              <div class="card-header-actions">
                <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
              </div>
            </div>
            <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>ID Number</label></b-input-group-prepend>
                      <b-form-input v-model="model.crewnik" placeholder="ID Number" :state="!$v.model.crewnik.$error"></b-form-input>
                      <b-form-radio-group class="ml-2 mt-2" v-model="model.terminate" name="radioTerminate">
                        <b-form-radio value="0">Active</b-form-radio>
                        <b-form-radio value="1">Terminate/Resign</b-form-radio>
                      </b-form-radio-group>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Name</label></b-input-group-prepend>
                      <b-form-input v-model="model.crewname" placeholder="Name" :state="!$v.model.crewname.$error"></b-form-input>
                      <b-form-checkbox  class="ml-1 mt-2" v-model="model.crewmale" value=1 unchecked-value=0>MALE</b-form-checkbox>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Date of Birth</label></b-input-group-prepend>
                      <b-form-input v-model="model.crewpob" placeholder="Place Of Birth"></b-form-input>
                      <b-form-input v-model="model.crewdob" type="date"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Home Addres</label></b-input-group-prepend>
                        <b-form-textarea id="crewaddr" v-model="model.crewaddr"
                          placeholder="Home Address..." rows="3" max-rows="6"></b-form-textarea>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Phone</label></b-input-group-prepend>
                      <b-form-input v-model="model.crewhp" placeholder="Mobile Phone" :state="!$v.model.crewhp.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Email</label></b-input-group-prepend>
                      <b-form-input v-model="model.crewmail" type="email" :state="!$v.model.crewmail.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Marital Status</label></b-input-group-prepend>
                        <b-form-select v-model="model.kawin" :plain="true" :options="maritalStatus"></b-form-select>
                        <b-input-group-prepend><span class="pt-2">&nbsp; Dependent &nbsp; </span></b-input-group-prepend>    
                        <b-form-input v-model="model.tanggungan" type="number"></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">person(s)</span></b-input-group-prepend>    
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>NPWP</label></b-input-group-prepend>
                      <b-form-input v-model="model.npwp" placeholder="Mobile Phone"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>NPWP Address</label></b-input-group-prepend>
                        <b-form-textarea id="alamatwp" v-model="model.alamatwp"
                          placeholder="NPWP Address..." rows="3" max-rows="6"></b-form-textarea>
                    </b-input-group>
                </b-col>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Date of Join</label></b-input-group-prepend>
                      <b-form-input v-model="model.joinDate" type="date"></b-form-input>
                        <b-input-group-prepend><span class="pt-2">&nbsp; Start Permanent &nbsp;</span></b-input-group-prepend>    
                      <b-form-input v-model="model.awaltetap" type="date"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Job Title</label></b-input-group-prepend>
                      <b-form-input v-model="model.jabatan" placeholder="Job Title" :state="!$v.model.jabatan.$error"></b-form-input>
                    </b-input-group>
                    <b-row no-gutters>
                       <b-col md="6">
                          <b-input-group >
                            <b-input-group-prepend><label>Position/Pangkat</label></b-input-group-prepend>
                              <!-- <b-form-select v-model="model.pangkatid" :plain="true" :options="jobPositions" :state="!$v.model.pangkatid.$error"></b-form-select> -->
                              <b-form-input readonly v-model="model.pangkat" :state="!$v.model.pangkatid.$error"></b-form-input>
                              <b-input-group-append>
                                  <b-btn text="Button" @click="lkuPangkatShow=true" ><i class="fa fa-search"></i></b-btn>
                              </b-input-group-append>
                          </b-input-group>
                       </b-col>
                       <b-col md="6">
                        <b-input-group >
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Grade/Golongan</span></b-input-group-prepend>
                            <!-- <b-form-select v-model="model.golonganid" :plain="true" :options="jobGroups" :state="!$v.model.golonganid.$error"></b-form-select> -->
                            <b-form-input readonly v-model="model.golongan" :state="!$v.model.golonganid.$error"></b-form-input>
                            <b-input-group-append>
                                <b-btn text="Button" @click="lkuGolonganShow=true" ><i class="fa fa-search"></i></b-btn>
                            </b-input-group-append>
                        </b-input-group>       
                       </b-col>
                    </b-row>
                    <b-row no-gutters>
                       <b-col md="6">
                          <b-input-group >
                            <b-input-group-prepend><label>Department</label></b-input-group-prepend>
                              <!-- <b-form-select v-model="model.departid" :plain="true" :options="departments" :state="!$v.model.departid.$error"></b-form-select> -->
                              <b-form-input readonly v-model="model.departemen" :state="!$v.model.departid.$error"></b-form-input>
                              <b-input-group-append>
                                  <b-btn text="Button" @click="lkuDepartmentShow=true" ><i class="fa fa-search"></i></b-btn>
                              </b-input-group-append>
                          </b-input-group>
                       </b-col>
                       <b-col md="6">
                          <b-input-group >
                              <b-input-group-prepend><span class="ml-2 pt-2 mr-1">UpLine/Manager</span></b-input-group-prepend>
                              <b-form-input readonly v-model="model.managerinfo" ></b-form-input>
                              <b-input-group-append>
                                  <b-btn text="Button" @click="lkuCrewShow=true" ><i class="fa fa-search"></i></b-btn>
                              </b-input-group-append>
                          </b-input-group>
                       </b-col>
                    </b-row>


                  <b-row no-gutters>
                     <b-col cols="8">
                        <b-input-group >
                          <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                              <b-form-radio-group class="mt-2" v-model="model.officer" name="radioOfficer">
                                <b-form-radio value="1">Office Worker</b-form-radio>
                                <b-form-radio value="0">Field Worker</b-form-radio>
                              </b-form-radio-group>
                        </b-input-group>
                        <b-input-group >
                          <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                              <b-form-radio-group class="mt-2" v-model="model.wni" name="radioWni">
                                <b-form-radio value="1">Indonesian (WNI)</b-form-radio>
                                <b-form-radio value="0">Expatriate</b-form-radio>
                              </b-form-radio-group>
                        </b-input-group>
                        <b-input-group >
                          <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                              <b-form-radio-group class="mt-2" v-model="model.staffTetap" name="radioTetap">
                                <b-form-radio value="0">Probation/Contract</b-form-radio>
                                <b-form-radio value="1">Permanent Employee</b-form-radio>
                              </b-form-radio-group>         
                        </b-input-group>
                        <div class="text-right mt-5 mr-1">
                          <b-button variant="btn btn-primary" @click="toggleShowImg()" > <i class="fa fa-file-image-o"></i> Upload Photo</b-button>
                        </div>
                     </b-col>
                     <b-col cols="4">
                                <my-upload field="gambar" 
                                    @crop-success="cropSuccess"
                                    @crop-upload-success="cropUploadSuccess"
                                    @crop-upload-fail="cropUploadFail"
                                    v-model="showImgTool"
                                    :width="100"
                                    :height="100"
                                    :url="imgUploadUrl"
                                    langType="en"
                                    :params="imgParams"
                                    :headers="imgHeaders"
                                    img-format="png"></my-upload>
                                <img :src="imgDataUrl" class="border border-primary" width="200" height="200">
                     </b-col>
                  </b-row>
                  
                </b-col>
            </b-row>
            <b-row class="justify-content-center mb-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()"><i class="fa fa-save"></i> Save</button>
                <b-button class="btn btn-primary mr-1" @click.stop="close()" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
    </b-card>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
        </b-modal>        
        <b-modal v-model="lkuDepartmentShow" size="lg" :hide-footer="true" title="List of Department" :centered="true">
            <lku-department @click="onSelectLkuDepartment"></lku-department>
        </b-modal>        
        <b-modal v-model="lkuGolonganShow" size="lg" :hide-footer="true" title="List of Grade/Golongan" :centered="true">
            <lku-golongan @click="onSelectLkuGolongan"></lku-golongan>
        </b-modal>        
        <b-modal v-model="lkuPangkatShow" size="lg" :hide-footer="true" title="List of Position/Pangkat" :centered="true">
            <lku-pangkat @click="onSelectLkuPangkat"></lku-pangkat>
        </b-modal>        
  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>
<script>
import moment from 'moment';
import 'babel-polyfill'; // es6 shim
import myUpload from 'vue-image-crop-upload';
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
import crew from "../../apis/crew";
import lkuCrew from "../lookup/lkuCrewlazzy";
import lkuDepartment from "../lookup/lkuDepartment";
import lkuGolongan from "../lookup/lkuGolongan";
import lkuPangkat from "../lookup/lkuPangkat";
import toastr from "mini-toastr";
toastr.init();

export default {   
  components:{myUpload,lkuCrew,lkuDepartment,lkuGolongan,lkuPangkat},
  mixins: [validationMixin],
  validations: {
        model: {
            crewnik: { required },
            crewname: { required },
            jabatan: { required },
            departid: { required },
            golonganid: { required },
            pangkatid: { required },
            crewhp: { required },
            crewmail: { required }
        },
  }, 
  data () {
    return {
        horizontal:true,
        saveEnabled:true,
        model: {
            crewnik: '',
            crewname: '',
            jabatan: '',
            departid: '',
            golonganid: '',
            pangkatid: '',
            crewhp: '',
            crewmail: '',terminate:0, crewmale: 1,terminate:0, crewmale: 1,
        },

        showImgTool:false,
        imgParams:{name:'gambar'},
        imgHeaders:{},
        imgDataUrl: '',
        imgUploadUrl: '',
        lkuCrewData:{},
        lkuCrewShow:false,
        lkuDepartmentShow:false,
        lkuGolonganShow:false,
        lkuPangkatShow:false,
        currency:[{value:'IDR',text:'IDR'}],
        maritalStatus: [{value:0,text:'SINGLE'},{value:1,text:'MARRIED'}],
        // departments:[],
        // jobPositions:[],
        // jobGroups:[]
    }
  },
  computed: {
      invalidModel() {
        this.$v.model.$touch();
        return this.$v.model.$invalid;
      },
      inventory() {
          return this.model.inventory;
      },

  },
  created: async function(){
      if (this.$route.params.crewkey)  {
          toastr.info('Loading Crew Detail, please wait')
          try {
            const data = await crew.detail(this.$route.params);  
            // const [a,b,c,data] = await Promise.all([crew.department(),crew.position(),crew.group(),crew.detail(this.$route.params)]) ;
            // this.departments = a; 
            // this.jobPositions = b; 
            // this.jobGroups = c; 
            // for (var key in data.crew) {
            //     this.model[key] = data.crew[key];
            // }
            // for (var key in data.contract) {
            //     this.model[key] = data.contract[key];
            // }
            data.crewdob = data.crewdob ? moment(data.crewdob).format('YYYY-MM-DD') : '';
            data.joinDate = data.joinDate ? moment(data.joinDate).format('YYYY-MM-DD') : '';
            data.awaltetap = data.awaltetap ? moment(data.awaltetap).format('YYYY-MM-DD') : '';
            for (var key in data) {
                this.model[key] = data[key];
            }

            this.imgDataUrl=this.model.photo || '';
            this.$forceUpdate();
            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "ERROR MESSAGE",10000);                              
          }
      } 
      // else {
      //       const [a,b,c] = await Promise.all([crew.department(),crew.position(),crew.group()]) ;
      //       this.departments = a; 
      //       this.jobPositions = b; 
      //       this.jobGroups = c; 
      // }

  },
  methods:{
    onSelectLkuCrew: async function (lkuData) {
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
        this.model.managerinfo = lkuData.selected.crewnik.trim() + ' | ' + lkuData.selected.crewname.trim();
        this.model.managerkey = lkuData.selected.crewkey;
        this.lkuCrewShow=false;
    },
    onSelectLkuDepartment: async function (_selected) {
        this.model.departemen = _selected.departemen.trim();
        this.model.departid = _selected.departid;
        this.model.departkd = _selected.departkd;
        this.lkuDepartmentShow=false;
    },
    onSelectLkuGolongan: async function (_selected) {
        this.model.golongan = _selected.golongan.trim();
        this.model.golonganid = _selected.golonganid;
        this.model.golongankd = _selected.golongankd;
        this.lkuGolonganShow=false;
    },
    onSelectLkuPangkat: async function (_selected) {
        this.model.pangkat = _selected.pangkat.trim();
        this.model.pangkatid = _selected.pangkatid;
        this.model.pangkatkd = _selected.pangkatkd;
        this.lkuPangkatShow=false;
    },

    save: async function(){
        if (!this.saveEnabled) {
            return;
        }
        this.saveEnabled=false;            
        if (this.invalidModel) {
            console.log('validation  : ', this.$v.model);
            console.log('model : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
       } else {
            try {
              const data={};
              for (var key in this.model) {
                  data[key] = this.model[key];
              }
              data.photo=this.imgDataUrl;
              data.crewdob = data.crewdob ? moment(data.crewdob).format('YYYY-MM-DD') : undefined;
              data.joinDate = data.joinDate ? moment(data.joinDate).format('YYYY-MM-DD') : undefined;
              data.awaltetap = data.awaltetap ? moment(data.awaltetap).format('YYYY-MM-DD') : undefined;

              await crew.save(data);
              this.close();
            } catch (error) {
                this.saveEnabled=true;            
                if (error.message) {
                    toastr.error(error.message, "ERROR MESSAGE",10000);
                } else {
                    toastr.error(JSON.stringify(error), "ERROR MESSAGE",10000);
                }              
            }
        }
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'receivable.arinvpayview')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'advance.crew'});
      }
    },    
          toggleShowImg() {
                this.showImgTool = !this.showImgTool;
            },
            /**
             * crop success
             *
             * [param] imgDataUrl
             * [param] field
             */
            cropSuccess(imgDataUrl, field){
                console.log('-------- crop success --------', field);
                this.imgDataUrl=imgDataUrl;
                // console.log(imgDataUrl);
                // console.log('content ',this[field]);
            },
            /**
             * upload success
             *
             * [param] jsonData  server api return data, already json encode
             * [param] field
             */
            cropUploadSuccess(jsonData, field){
                console.log('-------- upload success --------');
                // console.log(jsonData);
                console.log('field: ' + field);
            },
            /**
             * upload fail
             *
             * [param] status    server api return error status, like 500
             * [param] field
             */
            cropUploadFail(status, field){
                console.log('-------- upload fail --------');
                // console.log(status);
                // console.log('field: ' + field);
            }


  }
}
</script>